import { Close } from "@mui/icons-material";
import { IconButton, Snackbar } from "@mui/material";
import { useState } from "react";
import { createContext } from "react";

export const SnackbarContext = createContext();

export const SnackbarContextProvider = ({ children }) => {
  const [config, setConfig] = useState({
    vertical: "bottom",
    horizontal: "center",
    open: false,
    message: "",
    autoHideDuration: 6000
  });
  const { vertical, horizontal, open, message, autoHideDuration } = config;

  const showSnackbar = (newConfig) => {
    setConfig({ ...config, ...newConfig, open: true });
  };

  const handleClose = () => {
    setConfig({ ...config, open: false });
  };

  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <Close fontSize="small" />
      </IconButton>
    </>
  );
  return (
    <SnackbarContext.Provider
      value={{
        showSnackbar
      }}
    >
      {children}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        message={message}
        autoHideDuration={autoHideDuration}
        action={action}

      />
    </SnackbarContext.Provider>
  );
};

export default SnackbarContextProvider;
